import React from "react";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";

import { Column, CustomDRTReportItem } from "../../../utils/models";
import { formatTime, getChunkedData } from "../../../utils/utilities";
import { APP_DATE_FORMAT, SOURCES } from "../../../utils/constants";
import { useAppSelector } from "../../../store/configureStore";
import { getReportDetails } from "../../../store/reportDetails";

type GeneralInformationItem = Pick<CustomDRTReportItem, 'id' | 'source' | 'sourceActivity' | 'sourceManufacturer' | 'sourceSize' | 'contrastUsed' | 'equipmentSerialNumber' | 'imageFilmType' | 'serialNumber' | 'drtScannerCalibrationDate' | 'sourceConformityInspectionDate' | 'pipeSpecification' | 'drtScannerModalName' | 'pipeMaterialClass'>

type Props = {
    reportItems: GeneralInformationItem[];
};

const GeneralInformation: React.FC<Props> = ({ reportItems }) => {
    const { itemCountPerPage } = useAppSelector(getReportDetails);
    
    return ( 
        <>
            {getChunkedData(reportItems, itemCountPerPage).map((chunk, index) => (
                <CustomSection key={index} sectionTitle="General Information">
                    <div className="table-responsive p-1">
                        <PDFTablePage data={chunk} columns={columns} />
                    </div>
                </CustomSection>  
            ))}
        </>      
    );
};
 
const columns: Column[] = [
    {
        path: 'id',
        label: 'S/N',
    },
    {
        path: 'source',
        label: 'Source',
    },
    {
        path: 'sourceManufacturer',
        label: 'Source Manufacturer',
    },
    {
        path: 'sourceActivity',
        label: 'Source Activity',
        content: (item: GeneralInformationItem) => {
            const source = SOURCES.find((source) => source.id === item.source);
            return <span>{item.sourceActivity} {source ? `(${source.unit})` : ''}</span>
        }
    },
    {
        path: 'sourceSize',
        label: 'Source Size (mm)',
    },
    {
        path: 'equipmentSerialNumber',
        label: 'Source Serial Number',
    },
    {
        path: 'contrastUsed',
        label: 'Contrast Used',
    },
    {
        path: 'pipeSpecification',
        label: 'Material Specification',
    },
    {
        path: 'imageFilmType',
        label: 'Image Type',
    },
    {
        path: 'pipeMaterialClass',
        label: 'Pipe Material Class',
    },
    {
        path: 'drtScannerModalName',
        label: 'DRT Scanner Name',
    },
    {
        path: 'serialNumber',
        label: 'DRT Scanner Serial Number',
    },
    {
        path: 'drtScannerCalibrationDate',
        label: 'DRT Scanner Calibration Due Date',
        content: (item: GeneralInformationItem) => formatTime(item.drtScannerCalibrationDate, APP_DATE_FORMAT)
    },
    {
        path: 'sourceConformityInspectionDate',
        label: 'Source Conformity Inspection Date',
        content: (item: GeneralInformationItem) => formatTime(item.sourceConformityInspectionDate, APP_DATE_FORMAT)
    },
];

export default GeneralInformation;